"use strict";
exports.set = set;
var _index = require("./constructFrom.js");
var _index2 = require("./setMonth.js");
var _index3 = require("./toDate.js");
function set(date, values) {
  let _date = (0, _index3.toDate)(date);
  if (isNaN(+_date)) {
    return (0, _index.constructFrom)(date, NaN);
  }
  if (values.year != null) {
    _date.setFullYear(values.year);
  }
  if (values.month != null) {
    _date = (0, _index2.setMonth)(_date, values.month);
  }
  if (values.date != null) {
    _date.setDate(values.date);
  }
  if (values.hours != null) {
    _date.setHours(values.hours);
  }
  if (values.minutes != null) {
    _date.setMinutes(values.minutes);
  }
  if (values.seconds != null) {
    _date.setSeconds(values.seconds);
  }
  if (values.milliseconds != null) {
    _date.setMilliseconds(values.milliseconds);
  }
  return _date;
}
